/**
 * Hook to fetch the book catalog directly from the BuxBox Story Builder.
 */
import { useQuery } from '@tanstack/react-query';
import { getBuilderCatalog } from '@/lib/builder-books';
import type { BuilderBook } from '@/integrations/builder/types';

export function useBuilderCatalog() {
  return useQuery<BuilderBook[]>({
    queryKey: ['builder-catalog'],
    queryFn: getBuilderCatalog,
    staleTime: 30 * 1000, // 30s — let cover/asset updates from the Builder propagate quickly
    refetchOnWindowFocus: true,
  });
}
